import styled from "styled-components";

export const Wrapper = styled.div`
    display: flex;
    width: 100%;
    > * {
        cursor: ${(props) => (props.enableClick ? "pointer" : "initial")};
    }
`;

export const TagWrapper = styled.div`
    margin-left: 0.3rem;
    height: min-content;
`;

export const Title = styled.div`
    font-size: 9px;
    font-family: ${globalThis.config.fonts.families.light};
    color: ${globalThis.config.colors.gray2};
`;

export const Office = styled.div`
    font-size: 9px;
    font-family: ${globalThis.config.fonts.families.light};
    color: ${globalThis.config.colors.gray2};
`;

export const Name = styled.div`
    width: 180px;
    display: flex;
    align-items: center;
    color: ${globalThis.config.colors.black};
    font-family: ${globalThis.config.fonts.families.medium};
    font-size: ${globalThis.config.fonts.sizes.small};
    padding-left: 0.75rem;
    padding-top: 0.25rem;
`;

export const Details = styled.div`
    width: 120px;
    display: grid;
`;
